$(self).ready(() => {
	/**
	 *
	 */
	$(".dropdown-control[data-action=click]").on("click", function (event) {
		event.preventDefault();

		const tar = $(this).data("target");
		//toggle the dropdown
		$(".dropdown").not(`.${tar}`).removeClass("active");
		$(".dropdown-control").not(this).removeClass("active");
		$(`.${tar}`).toggleClass("active");
		$(this).toggleClass("active");
		$("body").toggleClass("tpm-dropdown-active");
	});

	//nothing uses hover anymore but here it is
	$(".dropdown-control[data-action=hover]").hover(function (event) {
		event.preventDefault();
		const tar = $(this).data("target");
		$(".dropdown").not(`.${tar}`).removeClass("active");
		$(".dropdown-control").not(this).removeClass("active");
		$(`.${tar}`).toggleClass("active");
		$(this).toggleClass("active");
	});

	//closes all dropdowns, ensuring only 1 is ever open at a time
	$(".dropdown-closer").on("click", function (event) {
		$(".dropdown").removeClass("active");
		$(".dropdown-control").removeClass("active");
		$(".js_modal-overlay").removeClass("--active");
		$("body").removeClass("tpm-dropdown-active");
	});

	// if the target is not a dropdown-control, dropdown, or a descendant element of a dropdown
	// then close all dropdowns
	$("body").on("click", function (event) {
		if (
			!$(".dropdown-control").is(event.target) &&
			!$(".dropdown").is(event.target) &&
			$(".dropdown").has(event.target).length === 0
		) {
			resetTraySubNavs();
		}
	});

	//js_toTraySubNav
	//navigate between subnavs
	$(".js_toTraySubNav").on("click", function (event) {
		const tar = $(this).data("target");
		$(`#${tar}`).removeClass("--offscreen");
		$("#base").addClass("--left");
	});

	$(".js_toTrayMainNav").on("click", function (event) {
		const tar = $(this).data("self");
		$(`#${tar}`).addClass("--offscreen");
		$("#base").removeClass("--left");
	});
});

function resetTrayNavs() {
	$(".dropdown").removeClass("active");
	$(".dropdown-control").removeClass("active");
	$(".js_modal-overlay").removeClass("--active");
	$("body").removeClass("tpm-dropdown-active");
	resetTraySubNavs();
}

function resetTraySubNavs() {
	$(".TrayMenu__Nav").removeClass("--left");
	$(".TrayMenu__Nav").addClass("--offscreen");
	//reactivate the main nav
	$("#base").removeClass("--offscreen");
	$(".TrayMenu__Nav.--always-active").removeClass("--offscreen");
}
